import { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import { COMMON_CONTAINER_ID } from '@/config';
import { SvgIcon } from '@/components';
import { Helmet } from 'react-helmet';

import styles from './Banners.module.sass';
import BannerItem from './BannerItem';

interface BannersProps {}

export type BannerType = {
  width: number;
  height: number;
};

const banners: BannerType[] = [
  {
    width: 100,
    height: 100,
  },
  {
    width: 88,
    height: 31,
  },
  {
    width: 468,
    height: 60,
  },
  {
    width: 120,
    height: 600,
  },
];

const Banners: FC<BannersProps> = () => {
  return (
    <>
      <Helmet>
        <title>AMLBot - Banners</title>
        <meta
          name="description"
          content="Access promotional banners and marketing materials for AMLBot. Enhance your compliance campaign with our resources."
        />
      </Helmet>
      <div className={styles.banners}>
        <div className={styles.header}>
          <a href="/" className={styles.backButton}>
            <SvgIcon name="arrow-back" />
            Back
          </a>
        </div>

        <div className={styles.inner}>
          {banners.map((banner) => {
            return (
              <BannerItem
                key={`${banner.width}x${banner.height}`}
                width={banner.width}
                height={banner.height}
              />
            );
          })}
        </div>
      </div>

      <ToastContainer
        containerId={COMMON_CONTAINER_ID}
        position="top-center"
        limit={3}
        enableMultiContainer
      />
    </>
  );
};

export default Banners;
